// Loading shimmer in the SHAPE of what is loading (rule 9) — never a spinner
// in the middle of the screen. DataTable and KpiStrip have it built in.

export interface SkeletonProps {
  width?: number | string;
  height?: number | string;
  radius?: number | string;
  className?: string;
}

export function Skeleton({ width = '100%', height = 14, radius = 8, className }: SkeletonProps) {
  return <span className={`e-skel ${className ?? ''}`} style={{ width, height, borderRadius: radius }} aria-hidden="true" />;
}

/** The pulsing dot used for «refreshing» (old data stays on screen). */
export function RefreshDot({ label = 'جارٍ التحديث' }: { label?: string }) {
  return (
    <span className="e-refresh" role="status" aria-label={label}>
      <span className="e-pulse" aria-hidden="true" />
    </span>
  );
}
